import {gql} from '@apollo/client'

export const POLICY_FIELDS_FRAGMENT = gql`
  fragment PolicyFields on policy_type {
    id
    created
    updated
    CMSPlanId
    FFM
    NPN
    applicants
    dependents
    effectiveDate
    marketplaceId
    memberId
    members
    metalLevel
    paymentStatus
    planName
    policyTotalCost
    premium
    stateDocs
    documentsDueDate
    taxCredit
    typeSale
    policyName
    nominalValue
    percentageValue
    ownsCar
    ownsHome
    hasAutoPolicy
    hasHomePolicy
    hasCarrierAccount
    accountUsername
    accountPassword
    accountCreatedByClient
    status
    canceledDate
    completedDate
    type
    apizealCode
    commissionPayable
    city
    zipCode
    address1
    address2
    countyFips
    stateEU {
      name
      id
      code
      jurisdictionType
    }
    mailingAddress1
    mailingAddress2
    mailingCity
    mailingZipCode
    mailingCountyFips
    mailingStateeu {
      name
      id
      code
    }
    archivedDate
    isImportant
    assignedTo {
      id
      firstName
      lastName
    }
    user {
      id
      firstName
      lastName
    }
    createdBy {
      id
      firstName
      lastName
    }
    typePolicy {
      id
      typePolicy
      kind
    }
    carrier {
      id
      name
    }
    leadSource {
      id
      name
    }
    lead {
      id
      name
    }
    sourcePolicy {
      pk
      policyName
      effectiveDate
    }
    policyFamily {
      pk
      parentPk
      depth
      policyName
      status
      effectiveDate
      created
      updated
      agentName
      assignedToName
      holderName
      holderPhone
      stateCode
      zipCode
      carrierName
      planName
      policyTypeId
      policyTypeName
      metalLevel
      premium
      npn
      applicants
      isDuplicated
      stateDocs
      documentsDueDate
      paymentStatus
      carrierStatusGeneric
      carrierStatusRaw
      carrierIsAgeIn
      carrierIsDelinquent
    }
    contactNetwork {
      pk
      policyName
      status
      effectiveDate
      agentName
      assignedToName
      holderName
      carrierName
      planName
      policyTypeId
      policyTypeName
      applicants
      stateDocs
      paymentStatus
      carrierStatusGeneric
      carrierIsAgeIn
      carrierIsDelinquent
    }
    holderMember {
      id
      firstName
      lastName
      emailAddress
      phone
      dateBirth
      immigrationStatus
      healthsherpaContactId
      healthsherpaSyncAt
    }
    memberPolicySet {
      edges {
        node {
          id
          applicant
          firstName
          lastName
          dateBirth
          immigrationStatus
          created
          updated
          rol
          relationship
          middleName
          lastName
          secondLastName
          contact {
            id
          }
          preferredLenguage
          dateBirth
          gender
          emailAddress
          phone
          maritalStatus
          countryBirth
          usesTobacco
          isPregnant
          hasMec
          isBeneficiary
          beneficiaryClass
          beneficiaryPercentage
          beneficiaryAddress
          hasFelony
          hasBankruptcy
          hasDui
          backgroundExplanation
          weight
          height
          immigrationStatus
          immigrationStatusCode
          uscis
          passport
          ssn
          ssnIssuedDate
          greenCard
          greenCardIssuedDate
          greenCardExpirationDate
          workPermitCard
          workPermitIssuedDate
          workPermitExpirationDate
          driverLicense
          driverLicenseExpirationDate
          medicareNumber
          medicarePartAStartDate
          medicarePartBStartDate
          employerName1
          selfEmployed1
          employerPhone1
          positionOccupation1
          annualIncome1
          employerName2
          selfEmployed2
          employerPhone2
          positionOccupation2
          annualIncome2
          employerName3
          selfEmployed3
          employerPhone3
          positionOccupation3
          annualIncome3
          contact {
            id
          }
        }
      }
    }
    policyPayment {
      id
      recurrentPayment
      typeCard
      cardCompany
      cardNumber
      expirationMonth
      expirationDay
      cvvCsv
      firstPaymentDate
      bankAccount
      bankName
      accountType
      ABARouting
      accountNumber
      preferredPayment
      billingAddress
      paymentHolder
      address1
      address2
      city
      zipCode
      stateEU {
        name
        id
      }
      policy {
        id
      }
    }
    policyExtraInfo {
      id
      primaryDoctorInfo
      medicinesNeeded
      infoExtra
      cancellationDate
      specialEnrollmentDate
      specialEnrollmentReason
    }
    lifeDetail {
      id
      faceAmount
      paymentFrequency
      ownerIsInsured
      ownerName
      ownerRelationship
      ownerSsn
      ownerDateBirth
      ownerAddress
      hasExistingLifeInsurance
      existingCarrierName
      existingPolicyNumber
      existingPlanName
      existingFaceAmount
      existingEffectiveDate
      willBeReplaced
      personalNetWorth
      householdIncome
      householdNetWorth
      medicalConditions
      tobaccoProductType
      tobaccoFrequency
      tobaccoLastUsedDate
      physicianName
      physicianLastVisitDate
      physicianLastVisitReason
      physicianAddress
      fatherLiving
      fatherAge
      fatherAgeDeath
      fatherDeathCause
      motherLiving
      motherAge
      motherAgeDeath
      motherDeathCause
    }
    lifeMedications {
      id
      name
      dosage
      frequency
      diagnosis
    }
    policyAttachmentsSet {
      edges {
        node {
          id
          created
          name
          expirationDate
          attachments
          comments
          memberPolicy {
            id
            firstName
            lastName
          }
          documentTag {
            id
            tagName
          }
          user {
            id
            firstName
            lastName
          }
          policy {
            id
          }
        }
      }
    }
  }
`

export const POLICY_FIELDS_NO_ATTACHMENTS_FRAGMENT = gql`
  fragment PolicyFieldsNoAttachments on policy_type {
    id
    created
    updated
    CMSPlanId
    FFM
    NPN
    applicants
    dependents
    effectiveDate
    marketplaceId
    memberId
    members
    metalLevel
    paymentStatus
    planName
    policyTotalCost
    premium
    stateDocs
    documentsDueDate
    taxCredit
    typeSale
    policyName
    nominalValue
    percentageValue
    ownsCar
    ownsHome
    hasAutoPolicy
    hasHomePolicy
    hasCarrierAccount
    accountUsername
    accountPassword
    accountCreatedByClient
    status
    canceledDate
    completedDate
    type
    apizealCode
    commissionPayable
    city
    zipCode
    address1
    address2
    countyFips
    stateEU {
      name
      id
      code
      jurisdictionType
    }
    mailingAddress1
    mailingAddress2
    mailingCity
    mailingZipCode
    mailingCountyFips
    mailingStateeu {
      name
      id
      code
    }
    archivedDate
    isImportant
    assignedTo {
      id
      firstName
      lastName
    }
    user {
      id
      firstName
      lastName
    }
    createdBy {
      id
      firstName
      lastName
    }
    typePolicy {
      id
      typePolicy
      kind
    }
    carrier {
      id
      name
    }
    leadSource {
      id
      name
    }
    lead {
      id
      name
    }
    sourcePolicy {
      pk
      policyName
      effectiveDate
    }
    policyFamily {
      pk
      parentPk
      depth
      policyName
      status
      effectiveDate
      created
      updated
      agentName
      assignedToName
      holderName
      holderPhone
      stateCode
      zipCode
      carrierName
      planName
      policyTypeId
      policyTypeName
      metalLevel
      premium
      npn
      applicants
      isDuplicated
      stateDocs
      documentsDueDate
      paymentStatus
      carrierStatusGeneric
      carrierStatusRaw
      carrierIsAgeIn
      carrierIsDelinquent
    }
    contactNetwork {
      pk
      policyName
      status
      effectiveDate
      agentName
      assignedToName
      holderName
      carrierName
      planName
      policyTypeId
      policyTypeName
      applicants
      stateDocs
      paymentStatus
      carrierStatusGeneric
      carrierIsAgeIn
      carrierIsDelinquent
    }
    holderMember {
      id
      firstName
      lastName
      emailAddress
      phone
      dateBirth
      immigrationStatus
      healthsherpaContactId
      healthsherpaSyncAt
    }
    memberPolicySet {
      edges {
        node {
          id
          applicant
          firstName
          created
          updated
          rol
          relationship
          middleName
          lastName
          secondLastName
          contact {
            id
          }
          preferredLenguage
          dateBirth
          gender
          emailAddress
          phone
          maritalStatus
          countryBirth
          usesTobacco
          isPregnant
          hasMec
          isBeneficiary
          beneficiaryClass
          beneficiaryPercentage
          beneficiaryAddress
          hasFelony
          hasBankruptcy
          hasDui
          backgroundExplanation
          weight
          height
          immigrationStatus
          immigrationStatusCode
          uscis
          passport
          ssn
          ssnIssuedDate
          greenCard
          greenCardIssuedDate
          greenCardExpirationDate
          workPermitCard
          workPermitIssuedDate
          workPermitExpirationDate
          driverLicense
          driverLicenseExpirationDate
          medicareNumber
          medicarePartAStartDate
          medicarePartBStartDate
          employerName1
          selfEmployed1
          employerPhone1
          positionOccupation1
          annualIncome1
          employerName2
          selfEmployed2
          employerPhone2
          positionOccupation2
          annualIncome2
          employerName3
          selfEmployed3
          employerPhone3
          positionOccupation3
          annualIncome3
          contact {
            id
          }
        }
      }
    }
    policyPayment {
      id
      recurrentPayment
      typeCard
      cardCompany
      cardNumber
      expirationMonth
      expirationDay
      cvvCsv
      firstPaymentDate
      bankAccount
      bankName
      accountType
      ABARouting
      accountNumber
      preferredPayment
      billingAddress
      paymentHolder
      address1
      address2
      city
      zipCode
      stateEU {
        name
        id
      }
      policy {
        id
      }
    }
    policyExtraInfo {
      id
      primaryDoctorInfo
      medicinesNeeded
      infoExtra
      cancellationDate
      specialEnrollmentDate
      specialEnrollmentReason
    }
    lifeDetail {
      id
      faceAmount
      paymentFrequency
      ownerIsInsured
      ownerName
      ownerRelationship
      ownerSsn
      ownerDateBirth
      ownerAddress
      hasExistingLifeInsurance
      existingCarrierName
      existingPolicyNumber
      existingPlanName
      existingFaceAmount
      existingEffectiveDate
      willBeReplaced
      personalNetWorth
      householdIncome
      householdNetWorth
      medicalConditions
      tobaccoProductType
      tobaccoFrequency
      tobaccoLastUsedDate
      physicianName
      physicianLastVisitDate
      physicianLastVisitReason
      physicianAddress
      fatherLiving
      fatherAge
      fatherAgeDeath
      fatherDeathCause
      motherLiving
      motherAge
      motherAgeDeath
      motherDeathCause
    }
    lifeMedications {
      id
      name
      dosage
      frequency
      diagnosis
    }
  }
`

// Query optimizado para listado - solo trae campos necesarios para la tabla
export const GET_ALL_POLICIES_LIST = gql`
  query allPolicies(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $archived: Boolean
    $createdAfter: Date
    $createdBefore: Date
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $paymentStatusDateAfter: Date
    $paymentStatusDateBefore: Date
    $advisorPaidDateAfter: Date
    $advisorPaidDateBefore: Date
    $advisorChargeback: Boolean
    $advisorChargebackDateAfter: Date
    $advisorChargebackDateBefore: Date
    $completedAfter: Date
    $completedBefore: Date
    $canceledAfter: Date
    $canceledBefore: Date
    $archivedAfter: Date
    $archivedBefore: Date
    $stateEU: [String]
    $stateJurisdictionType: String
    $policyType: [String]
    $leadSource: [String]
    $status: [String]
    $documentStatus: [String]
    $paymentStatus: [String]
    $metalLevel: String
    $isImportant: Boolean
    $hasReminders: Boolean
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $commissionPaymentStatus: String
    $advisorPaid: Boolean
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $hasCarrierAccount: Boolean
    $accountCreatedByClient: Boolean
    $carrier: [String]
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $holderName: String
    $memberName: String
    $insuranceCategory: String
    $effectiveYear: [String]
    $immigrationStatus: [String]
    $holderGender: String
    $signatureStatus: String
    $signatureForm: [String]
    $agentOfRecord: [String]
    $carrierStatusGeneric: [String]
    $carrierStatusRaw: String
    $carrierLastAsOfDateAfter: Date
    $carrierLastAsOfDateBefore: Date
    $carrierIsAgeIn: Boolean
    $carrierIsDelinquent: Boolean
    $carrierIsUnpaidPending: Boolean
    $carrierIsUnpaidPastDue: Boolean
    $carrierNoImportData: Boolean
    $acaResult: String
    $acaValidity: String
    $orderBy: String
    $orderDirection: String
    $includeTotals: Boolean = true
  ) {
    allPolicies(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      archived: $archived
      createdBefore: $createdBefore
      createdAfter: $createdAfter
      effectiveDateBefore: $effectiveDateBefore
      effectiveDateAfter: $effectiveDateAfter
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      paymentStatusDateAfter: $paymentStatusDateAfter
      paymentStatusDateBefore: $paymentStatusDateBefore
      advisorPaidDateAfter: $advisorPaidDateAfter
      advisorPaidDateBefore: $advisorPaidDateBefore
      advisorChargeback: $advisorChargeback
      advisorChargebackDateAfter: $advisorChargebackDateAfter
      advisorChargebackDateBefore: $advisorChargebackDateBefore
      completedBefore: $completedBefore
      completedAfter: $completedAfter
      canceledBefore: $canceledBefore
      canceledAfter: $canceledAfter
      archivedBefore: $archivedBefore
      archivedAfter: $archivedAfter
      carrier: $carrier
      stateEU: $stateEU
      stateJurisdictionType: $stateJurisdictionType
      policyType: $policyType
      leadSource: $leadSource
      status: $status
      documentStatus: $documentStatus
      paymentStatus: $paymentStatus
      metalLevel: $metalLevel
      isImportant: $isImportant
      hasReminders: $hasReminders
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      commissionPaymentStatus: $commissionPaymentStatus
      advisorPaid: $advisorPaid
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      hasCarrierAccount: $hasCarrierAccount
      accountCreatedByClient: $accountCreatedByClient
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      holderName: $holderName
      memberName: $memberName
      insuranceCategory: $insuranceCategory
      effectiveYear: $effectiveYear
      immigrationStatus: $immigrationStatus
      holderGender: $holderGender
      signatureStatus: $signatureStatus
      signatureForm: $signatureForm
      agentOfRecord: $agentOfRecord
      carrierStatusGeneric: $carrierStatusGeneric
      carrierStatusRaw: $carrierStatusRaw
      carrierLastAsOfDateAfter: $carrierLastAsOfDateAfter
      carrierLastAsOfDateBefore: $carrierLastAsOfDateBefore
      carrierIsAgeIn: $carrierIsAgeIn
      carrierIsDelinquent: $carrierIsDelinquent
      carrierIsUnpaidPending: $carrierIsUnpaidPending
      carrierIsUnpaidPastDue: $carrierIsUnpaidPastDue
      carrierNoImportData: $carrierNoImportData
      acaResult: $acaResult
      acaValidity: $acaValidity
      orderBy: $orderBy
      orderDirection: $orderDirection
      includeTotals: $includeTotals
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      totalPolicies
      totalCanceled
      totalApplicantsPolicies
      totalApplicantsCanceled
      totalCompleted
      totalApplicantsCompleted
      totalPending
      totalApplicantsPending
      edges {
        node {
          id
          created
          updated
          policyName
          applicants
          stateDocs
          documentsDueDate
          paymentStatus
          NPN
          effectiveDate
          memberId
          planName
          metalLevel
          premium
          status
          user {
            firstName
            lastName
            email
            cellphone
            avatar
          }
          carrier {
            name
          }
          stateEU {
            code
          }
          holderMember {
            id
            firstName
            lastName
            phone
            rol
            dateBirth
            immigrationStatus
            healthsherpaContactId
            healthsherpaSyncAt
          }
          assignedTo {
            firstName
            lastName
          }
          zipCode
          isImportant
          archivedDate
          isDuplicated
          blockedDate
          commissionPayable
          ownsCar
          ownsHome
          hasAutoPolicy
          hasHomePolicy
          hasCarrierAccount
          accountCreatedByClient
          advisorPaid
          advisorPaidAt
          advisorChargeback
          advisorChargebackAt
          agentOfRecord
          latestAcaVerification {
            result
            created
          }
          carrierLastAsOfDate
          carrierStatusGeneric
          carrierStatusRaw
          carrierPaidThroughDate
          carrierBalance
          carrierAutopay
          carrierIsAgeIn
          carrierIsDelinquent
          carrierIsUnpaidPending
          carrierIsUnpaidPastDue
        }
      }
    }
  }
`

export const GET_ALL_POLICIES_TOTALS = gql`
  query allPoliciesTotals(
    $archived: Boolean
    $createdAfter: Date
    $createdBefore: Date
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $paymentStatusDateAfter: Date
    $paymentStatusDateBefore: Date
    $advisorPaidDateAfter: Date
    $advisorPaidDateBefore: Date
    $advisorChargeback: Boolean
    $advisorChargebackDateAfter: Date
    $advisorChargebackDateBefore: Date
    $completedAfter: Date
    $completedBefore: Date
    $canceledAfter: Date
    $canceledBefore: Date
    $archivedAfter: Date
    $archivedBefore: Date
    $stateEU: [String]
    $stateJurisdictionType: String
    $policyType: [String]
    $leadSource: [String]
    $status: [String]
    $documentStatus: [String]
    $paymentStatus: [String]
    $metalLevel: String
    $isImportant: Boolean
    $hasReminders: Boolean
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $commissionPaymentStatus: String
    $advisorPaid: Boolean
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $hasCarrierAccount: Boolean
    $accountCreatedByClient: Boolean
    $carrier: [String]
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $holderName: String
    $memberName: String
    $insuranceCategory: String
    $effectiveYear: [String]
    $immigrationStatus: [String]
    $holderGender: String
    $signatureStatus: String
    $signatureForm: [String]
    $agentOfRecord: [String]
    $carrierStatusGeneric: [String]
    $carrierStatusRaw: String
    $carrierLastAsOfDateAfter: Date
    $carrierLastAsOfDateBefore: Date
    $carrierIsAgeIn: Boolean
    $carrierIsDelinquent: Boolean
    $carrierIsUnpaidPending: Boolean
    $carrierIsUnpaidPastDue: Boolean
    $carrierNoImportData: Boolean
    $acaResult: String
    $acaValidity: String
    $includeTotals: Boolean = true
  ) {
    allPolicies(
      first: 1
      archived: $archived
      createdBefore: $createdBefore
      createdAfter: $createdAfter
      effectiveDateBefore: $effectiveDateBefore
      effectiveDateAfter: $effectiveDateAfter
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      paymentStatusDateAfter: $paymentStatusDateAfter
      paymentStatusDateBefore: $paymentStatusDateBefore
      advisorPaidDateAfter: $advisorPaidDateAfter
      advisorPaidDateBefore: $advisorPaidDateBefore
      advisorChargeback: $advisorChargeback
      advisorChargebackDateAfter: $advisorChargebackDateAfter
      advisorChargebackDateBefore: $advisorChargebackDateBefore
      completedBefore: $completedBefore
      completedAfter: $completedAfter
      canceledBefore: $canceledBefore
      canceledAfter: $canceledAfter
      archivedBefore: $archivedBefore
      archivedAfter: $archivedAfter
      carrier: $carrier
      stateEU: $stateEU
      stateJurisdictionType: $stateJurisdictionType
      policyType: $policyType
      leadSource: $leadSource
      status: $status
      documentStatus: $documentStatus
      paymentStatus: $paymentStatus
      metalLevel: $metalLevel
      isImportant: $isImportant
      hasReminders: $hasReminders
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      commissionPaymentStatus: $commissionPaymentStatus
      advisorPaid: $advisorPaid
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      hasCarrierAccount: $hasCarrierAccount
      accountCreatedByClient: $accountCreatedByClient
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      holderName: $holderName
      memberName: $memberName
      insuranceCategory: $insuranceCategory
      effectiveYear: $effectiveYear
      immigrationStatus: $immigrationStatus
      holderGender: $holderGender
      signatureStatus: $signatureStatus
      signatureForm: $signatureForm
      agentOfRecord: $agentOfRecord
      carrierStatusGeneric: $carrierStatusGeneric
      carrierStatusRaw: $carrierStatusRaw
      carrierLastAsOfDateAfter: $carrierLastAsOfDateAfter
      carrierLastAsOfDateBefore: $carrierLastAsOfDateBefore
      carrierIsAgeIn: $carrierIsAgeIn
      carrierIsDelinquent: $carrierIsDelinquent
      carrierIsUnpaidPending: $carrierIsUnpaidPending
      carrierIsUnpaidPastDue: $carrierIsUnpaidPastDue
      carrierNoImportData: $carrierNoImportData
      acaResult: $acaResult
      acaValidity: $acaValidity
      includeTotals: $includeTotals
    ) {
      totalCount
      totalPolicies
      totalCanceled
      totalApplicantsPolicies
      totalApplicantsCanceled
      totalCompleted
      totalApplicantsCompleted
      totalPending
      totalApplicantsPending
    }
  }
`

export const GET_ALL_POLICIES_API = gql`
  query allPolicies(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $archived: Boolean
    $createdAfter: Date
    $createdBefore: Date
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $paymentStatusDateAfter: Date
    $paymentStatusDateBefore: Date
    $advisorPaidDateAfter: Date
    $advisorPaidDateBefore: Date
    $advisorChargeback: Boolean
    $advisorChargebackDateAfter: Date
    $advisorChargebackDateBefore: Date
    $completedAfter: Date
    $completedBefore: Date
    $canceledAfter: Date
    $canceledBefore: Date
    $archivedAfter: Date
    $archivedBefore: Date
    $stateEU: [String]
    $stateJurisdictionType: String
    $policyType: [String]
    $leadSource: [String]
    $status: [String]
    $documentStatus: [String]
    $paymentStatus: [String]
    $isImportant: Boolean
    $hasReminders: Boolean
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $advisorPaid: Boolean
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $carrier: [String]
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $holderName: String
    $memberName: String
    $insuranceCategory: String
    $effectiveYear: [String]
    $immigrationStatus: [String]
    $holderGender: String
    $signatureStatus: String
    $signatureForm: [String]
    $agentOfRecord: [String]
  ) {
    allPolicies(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      archived: $archived
      createdBefore: $createdBefore
      createdAfter: $createdAfter
      effectiveDateBefore: $effectiveDateBefore
      effectiveDateAfter: $effectiveDateAfter
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      paymentStatusDateAfter: $paymentStatusDateAfter
      paymentStatusDateBefore: $paymentStatusDateBefore
      advisorPaidDateAfter: $advisorPaidDateAfter
      advisorPaidDateBefore: $advisorPaidDateBefore
      advisorChargeback: $advisorChargeback
      advisorChargebackDateAfter: $advisorChargebackDateAfter
      advisorChargebackDateBefore: $advisorChargebackDateBefore
      completedBefore: $completedBefore
      completedAfter: $completedAfter
      canceledBefore: $canceledBefore
      canceledAfter: $canceledAfter
      archivedBefore: $archivedBefore
      archivedAfter: $archivedAfter
      carrier: $carrier
      stateEU: $stateEU
      stateJurisdictionType: $stateJurisdictionType
      policyType: $policyType
      leadSource: $leadSource
      status: $status
      documentStatus: $documentStatus
      paymentStatus: $paymentStatus
      isImportant: $isImportant
      hasReminders: $hasReminders
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      advisorPaid: $advisorPaid
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      holderName: $holderName
      memberName: $memberName
      insuranceCategory: $insuranceCategory
      effectiveYear: $effectiveYear
      immigrationStatus: $immigrationStatus
      holderGender: $holderGender
      signatureStatus: $signatureStatus
      signatureForm: $signatureForm
      agentOfRecord: $agentOfRecord
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      totalPolicies
      totalCanceled
      totalApplicantsPolicies
      totalApplicantsCanceled
      totalCompleted
      totalApplicantsCompleted
      totalPending
      totalApplicantsPending
      edges {
        node {
          id
          created
          updated
          policyName
          applicants
          members
          dependents
          stateDocs
          documentsDueDate
          paymentStatus
          FFM
          NPN
          typeSale
          effectiveDate
          marketplaceId
          memberId
          CMSPlanId
          planName
          metalLevel
          policyTotalCost
          taxCredit
          premium
          percentageValue
          nominalValue
          status
          user {
            id
            firstName
            lastName
            email
            cellphone
          }
          createdBy {
            id
            firstName
            lastName
          }
          typePolicy {
            id
            typePolicy
            kind
          }
          leadSource{
            id
            name
          }
          carrier {
            id
            name
          }
          stateEU {
            code
            name
            id
          }
          memberPolicySet {
            edges {
              node {
                id
                applicant
                firstName
                lastName
                phone
                rol
              }
            }
          }
          policyPayment {
            id
            bankName
          }
          assignedTo {
            id
            firstName
            lastName
            email
            cellphone
          }
          zipCode
          isImportant
          archivedDate
          isDuplicated
          blockedDate
          mailingAddress1
          mailingAddress2
          mailingCity
          mailingZipCode
          mailingCountyFips
          mailingStateeu {
            name
            id
          }
          commissionPayable
          ownsCar
          ownsHome
          hasAutoPolicy
          hasHomePolicy
          hasCarrierAccount
          accountCreatedByClient
          advisorPaid
          advisorPaidAt
          advisorChargeback
          advisorChargebackAt
          agentOfRecord
          latestAcaVerification {
            result
            created
          }
        }
      }
    }
  }
`

export const GET_ONE_POLICY_API = gql`
  query policiesById($id: String) {
    policiesById(id: $id) {
      ...PolicyFields
    }
  }
  ${POLICY_FIELDS_FRAGMENT}
`

export const GET_ONE_POLICY_BASE_API = gql`
  query policiesById($id: String) {
    policiesById(id: $id) {
      ...PolicyFieldsNoAttachments
    }
  }
  ${POLICY_FIELDS_NO_ATTACHMENTS_FRAGMENT}
`

export const GET_ONE_POLICY_ATTACHMENTS_API = gql`
  query policiesById($id: String) {
    policiesById(id: $id) {
      id
      policyAttachmentsSet {
        edges {
          node {
            id
            created
            name
            expirationDate
            attachments
            comments
            memberPolicy {
              id
              firstName
              lastName
            }
            documentTag {
              id
              tagName
            }
            user {
              id
              firstName
              lastName
            }
            policy {
              id
            }
          }
        }
      }
    }
  }
`

export const GET_POLICY_DOCUMENTS_DUE_BY_RANGE = gql`
  query allPolicies(
    $first: Int
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $documentStatus: [String]
  ) {
    allPolicies(
      first: $first
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      documentStatus: $documentStatus
    ) {
      edges {
        node {
          id
          type
          policyName
          documentsDueDate
          holderMember {
            id
            firstName
            lastName
            dateBirth
            immigrationStatus
          }
        }
      }
    }
  }
`

export const GET_ALL_POLICIES_COUNT = gql`
  query allPolicies {
    allPolicies {
      totalCount
      totalPolicies
      totalCanceled
      totalApplicantsPolicies
      totalApplicantsCanceled
      totalCompleted
      totalApplicantsCompleted
      totalPending
      totalApplicantsPending
    }
  }
`

export const GET_DOCUMENTS_POLICY = gql`
  query allAttachmentsTags(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
  ) {
    allAttachmentsTags(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
    ) {
      edges {
        node {
          id
          tagName
        }
      }
    }
  }
`

export const GET_ALL_LOGS = gql`
  query policyLogsByPolicyId($policyId: Int!) {
    policyLogsByPolicyId(policyId: $policyId) {
      id
      oldValue
      newValue
      updatedAt
      user {
        id
        firstName
        lastName
      }
      changes
    }
  }
`

export const SEARCH_HEALTHSHERPA_CONTACT = gql`
  query searchHealthsherpaContact($memberId: Int!, $agentEmail: String, $searchField: String) {
    searchHealthsherpaContact(memberId: $memberId, agentEmail: $agentEmail, searchField: $searchField) {
      contacts {
        id
        firstName
        lastName
        email
        phone
        dateOfBirth
        status
        address1
        address2
        city
        state
        zip
        gender
      }
      agentEmail
      message
    }
  }
`

export const SYNC_MEMBER_TO_HEALTHSHERPA = gql`
  mutation syncMemberToMedicareHealthsherpa($memberId: Int!, $healthsherpaContactId: String, $agentEmail: String, $notes: String, $resync: Boolean) {
    syncMemberToMedicareHealthsherpa(memberId: $memberId, healthsherpaContactId: $healthsherpaContactId, agentEmail: $agentEmail, notes: $notes, resync: $resync) {
      success
      message
      healthsherpaContactId
      errors {
        field
        message
      }
    }
  }
`
